<template>
    <div class="cart-down">
        <div class="cart-down__inner">
            <div v-if="basket.price.productPrice > 0" id="js-cart-products-list" class="cart-down__products vertical-scrollbar'">
                <div class="d-block d-md-none cart-box__top">
                    <NuxtLink v-if="isPwa" class="btn btn-primary d-block btn-sm fs-13 fwsb d-md-none" :to="dictionary.cartStep1">
                        {{ dictionary.siteHeader.cartBox.goBasket }}
                    </NuxtLink>
                    <a v-else class="btn btn-primary d-block btn-sm fs-13 fwsb d-md-none" :href="dictionary.cartStep1">
                        {{ dictionary.siteHeader.cartBox.goBasket }}
                    </a>
                </div>

                <CartBoxProducts
                    @addProductToBasket="addProductToBasket"
                    class="cart-box__contents"
                    :products="basket.products"
                    :deposits="basket.deposits"
                    :discounts="basket.discounts"
                    :product-amounts="productAmounts"
                    :dictionary="dictionary"
                />

                <!--        <div-->
                <!--            v-if="basket.price.absoluteDiscount"-->
                <!--            class="cart-box-sale d-flex custom-font text-secondary my-3 fwb align-items-center fs-14 p-2 rounded"-->
                <!--        >-->
                <!--          <div class="cart-box-sale__img text-center">-->
                <!--            <i class="ico ico-order-sale-bottom me-1 ms-0"></i>-->
                <!--          </div>-->

                <!--          <div class="cart-box-sale__title">-->
                <!--            {{ dictionary.siteHeader.cartBox.youWillSave }}-->
                <!--          </div>-->

                <!--          <div class="cart-box-sale__price text-end">-->
                <!--            {{ basket.price.absoluteDiscount }}-->
                <!--          </div>-->
                <!--        </div>-->

                <!--        <div-->
                <!--            v-for="voucher in basket.vouchers"-->
                <!--            class="cart-box-sale d-flex custom-font text-secondary my-3 fwb align-items-center fs-14 p-2 rounded"-->
                <!--        >-->
                <!--          <div class="cart-box-sale__img text-center">-->
                <!--            <i class="ico ico-order-sale-coupon me-1 ms-0"></i>-->
                <!--          </div>-->

                <!--          <div class="cart-box-sale__title">-->
                <!--            {{ voucher.name }}-->
                <!--          </div>-->

                <!--          <div class="cart-box-sale__price text-end">-->
                <!--            {{ voucher.price }}-->
                <!--          </div>-->
                <!--        </div>-->
            </div>

            <div v-else class="pt-4">
                <div class="fwb text-center">
                    {{ dictionary.siteHeader.cartBox.youDoNotHaveANythingInYourBasketYet }}
                </div>
                <a :href="dictionary.url.category.sale" class="text-primary d-block text-center mt-1 text-decoration-underline">
                    {{ dictionary.siteHeader.cartBox.checkOutOurPriceHits }}
                </a>
            </div>
            <BannersMenu :cart-box-banner="cartBoxBanner" :class="{ 'pt-3': basket.products.length === 0 }" />
            <div v-if="basket.vouchers" class="px-2">
                <div
                    v-for="(voucher, index) in basket.vouchers"
                    :key="index"
                    class="cart-box__delivery-text p-2 pe-1 ps-1 d-flex text-success rounded-pill row"
                >
                    <div class="col-2 text-right">
                        <img
                            width="22"
                            height="15"
                            src="/nuxt-assets/images/icons/voucher.svg"
                            class="me-2 cart-box__delivery-text-ico"
                            :alt="voucher.name"
                        />
                    </div>
                    <div class="cart-box-sale__title col-8">
                        {{ voucher.name }}
                    </div>

                    <div class="cart-box-sale__price text-end col-2">
                        {{ $formatCurrency(voucher.price) }}
                    </div>
                </div>
            </div>
            <div
                class="cart-box__footer"
                :class="{ 'cart-box__footer--free': basket.freeDelivery.isEnabled || basket.discountedDelivery.isEnabled }"
            >
                <template v-if="basket.freeDelivery.isEnabled">
                    <div v-if="basket.freeDelivery.isFree" class="px-3">
                        <span class="cart-box__delivery-text p-2 pe-1 ps-1 text-center d-block text-success rounded-pill">
                            <img
                                width="18"
                                height="18"
                                src="/nuxt-assets/images/icons/check-green.svg"
                                class="me-2 cart-box__delivery-text-ico"
                                :alt="dictionary.siteHeader.cartBox.greatYouAreGettingFreeDelivery.uppercase"
                            />
                            <span
                                >{{ dictionary.siteHeader.cartBox.greatYouAreGettingFreeDelivery.text }}
                                <strong class="text-uppercase">{{
                                    dictionary.siteHeader.cartBox.greatYouAreGettingFreeDelivery.uppercase
                                }}</strong>
                            </span>
                        </span>
                    </div>
                    <div v-else class="p-2">
                        <div v-if="basket.price.productPrice > 0 && remainsInProgressBar > 0" class="progress mx-2 position-relative">
                            <div
                                class="progress-bar rounded-pill"
                                role="progressbar"
                                :style="`width: ${currentProgressBarPercent}%`"
                                :aria-valuenow="currentProgressBarPercent"
                                aria-valuemin="0"
                                aria-valuemax="100"
                            ></div>
                            <div class="position-absolute text-center fs-14 fwb w-100 free-delivery-status-text">
                                {{ currentProgressBar.title.replace('%amount%', $formatCurrency(remainsInProgressBar)) }}
                                <span v-if="dictionary.locale !== 'hu'" v-html="$formatCurrency(remainsInProgressBar)" />
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else-if="basket.discountedDelivery.isEnabled">
                    <div v-if="basket.discountedDelivery.isDiscounted" class="px-3">
                        <span class="cart-box__delivery-text p-2 pe-1 ps-1 text-center d-block text-success rounded-pill">
                            <img
                                width="18"
                                height="18"
                                src="/nuxt-assets/images/icons/check-green.svg"
                                class="me-2 cart-box__delivery-text-ico"
                                :alt="dictionary.siteHeader.cartBox.greatYouAreGettingFreeDelivery.uppercase"
                            />
                            <span
                                >{{ dictionary.siteHeader.cartBox.greatYouAreGettingDiscountedDelivery.text }}
                                <strong class="text-uppercase">{{
                                    dictionary.siteHeader.cartBox.greatYouAreGettingDiscountedDelivery.uppercase
                                }}</strong>
                            </span>
                        </span>
                    </div>
                    <div v-else class="p-2">
                        <div v-if="basket.price.productPrice > 0 && remainsInProgressBar > 0" class="progress mx-2 position-relative">
                            <div
                                class="progress-bar rounded-pill"
                                role="progressbar"
                                :style="`width: ${currentProgressBarPercent}%`"
                                :aria-valuenow="currentProgressBarPercent"
                                aria-valuemin="0"
                                aria-valuemax="100"
                            ></div>
                            <div class="position-absolute text-center fs-14 fwb w-100 free-delivery-status-text">
                                {{ currentProgressBar.title.replace('%amount%', $formatCurrency(remainsInProgressBar)) }}
                                <span v-if="dictionary.locale !== 'hu'" v-html="$formatCurrency(remainsInProgressBar)" />
                            </div>
                        </div>
                    </div>
                </template>
                <div class="row p-3">
                    <div class="col-lg-6 ml-auto">
                        <NuxtLink
                            v-if="isPwa"
                            class="d-block rounded-pill"
                            :class="hasFastCheckout ? 'btn btn-outline-primary' : 'btn btn-primary text-white'"
                            :to="dictionary.url.cartStep1"
                        >
                            {{ dictionary.siteHeader.cartBox.goBasket }}
                            <span class="arrow arrow--right" :class="{ 'arrow--primary arrow--hover-white': hasFastCheckout }"> </span>
                        </NuxtLink>
                        <a
                            v-else
                            class="d-block rounded-pill"
                            :class="hasFastCheckout ? 'btn btn-outline-primary' : 'btn btn-primary text-white'"
                            :href="dictionary.url.cartStep1"
                        >
                            {{ dictionary.siteHeader.cartBox.goBasket }}
                            <span class="arrow arrow--right" :class="{ 'arrow--primary arrow--hover-white': hasFastCheckout }"> </span>
                        </a>
                    </div>
                    <div v-if="hasFastCheckout" class="col">
                        <a class="js-show-new-checkout btn btn-primary btn-block text-white">
                            {{ dictionary.siteHeader.cartBox.fastCheckout }}
                            <i class="arrow arrow--right"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CartBoxProducts from './CartBoxProducts'
import BannersMenu from './BannersMenu'

export default {
    components: { CartBoxProducts, BannersMenu },

    props: {
        basket: {
            type: Object,
            required: true,
        },
        progressBars: {
            type: Array,
            default: () => {
                return []
            },
        },
        cartBoxBanner: {
            type: Object,
            required: true,
        },
        productAmounts: {
            type: Object,
            required: false,
            default: () => {},
        },
        dictionary: {
            type: Object,
            required: true,
        },
        isPwa: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            hasFastCheckout: false,
        }
    },
    computed: {
        currentProgressBar() {
            const progressBars = this.progressBars

            for (let i = 0; i < progressBars.length; i++) {
                if (this.basket.price.afterDiscountPrice < progressBars[i].price) {
                    return progressBars[i]
                }
            }

            return null
        },

        currentProgressBarPercent() {
            const currentProgressBar = this.currentProgressBar

            if (currentProgressBar === null) {
                return null
            }

            return Math.min((this.basket.price.afterDiscountPrice / currentProgressBar.price) * 100, 100)
        },

        remainsInProgressBar() {
            const currentProgressBar = this.currentProgressBar

            if (currentProgressBar === null) {
                return null
            }

            return currentProgressBar.price - this.basket.price.productPrice
        },
    },
    methods: {
        addProductToBasket(data) {
            this.$emit('addProductToBasket', data)
        },
    },
}
</script>

<style lang="scss">
.cartbox-banner {
    margin: 0 -18px;
}

@media (min-width: 768px) {
    .d-md-none {
        display: none !important;
    }
}

.site-header {
    .cart-box {
        position: absolute;
        display: none;
        top: 100%;
        margin-top: -1px;
        right: 0;
        background: #fff;
        padding: 10px;
        width: 540px;
        font-size: 14px;
        z-index: 2;

        @media (max-width: 767.98px) {
            position: fixed;
            top: 47px;
            width: 100%;
            left: 0;
            bottom: 0;
            background: #fff;
        }

        @media (min-width: 768px) {
            border-radius: 10px;
            overflow: hidden;
            box-shadow: 0 0 12px rgba(0, 0, 0, 0.1);
        }

        &--open {
            display: block;
            z-index: 20;

            @media (hover: none) {
                display: none;
            }
        }

        &__contents {
            max-height: 50vh;
            overflow-y: auto;
        }

        &__footer {
            background: #fff;
            margin: 15px -10px -10px;

            .progress {
                background: #fff;
                height: 36px;
                border: 2px solid #ecf4d9;
                border-radius: 36px;
            }

            .free-delivery-status-text {
                top: 8px;
            }

            .progress-bar {
                background: #ecf4d9;
                height: 100%;
                min-width: 36px;
            }
        }

        &__delivery-text {
            background: #ecf4d9;
            font-size: 13px;
            border-radius: 8px;

            &-ico {
                margin-top: -4px;
            }
        }
    }
}
</style>
